export function SurgeAlertIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M10.8286 5.17175C12.3907 6.73385 12.3907 9.26651 10.8286 10.8286M5.17174 10.8286C3.60964 9.26648 3.60964 6.73383 5.17174 5.17173M3.28612 12.7142C0.682622 10.1107 0.682622 5.88963 3.28612 3.28613M12.7142 3.28616C15.3177 5.88966 15.3177 10.1108 12.7142 12.7143M9.3335 8.00018C9.3335 8.73656 8.73654 9.33351 8.00016 9.33351C7.26378 9.33351 6.66683 8.73656 6.66683 8.00018C6.66683 7.2638 7.26378 6.66684 8.00016 6.66684C8.73654 6.66684 9.3335 7.2638 9.3335 8.00018Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
